import { Button, Col } from 'react-bootstrap';
import React, { useEffect } from 'react';
import './Trip.styles.scss';
import useGet from '../../../../services/useGet';
import { Property } from '../../../../types/property';
import moment from 'moment';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { ReactComponent as CalendarWhiteSVG } from '../../../../assets/calendar-white.svg';
import { useHistory } from 'react-router-dom';

interface TripProps {
  trip: any;
  property: Property;
  past?: boolean;
}

function Trip({ trip, property, past = false }: TripProps) {
  const history = useHistory();

  const goToTrip = () => {
    history.push(`/booking-confirm/${trip.BookingReference}`);
  };

  return (
    <Col lg={6} className={'flex p-0'}>
      <div className={'trip-box flex'}>
        <div className="col-md-4 p-0 trip-box-image">
          <LazyLoadImage src={property.picture} alt={property.name} className="trip-property-img" />
          <div className={'trip-dates'}>
            <CalendarWhiteSVG className={'calendar-white'} />
            <span>{moment(trip.CheckInDate).format('MMM DD')}</span>
            <span> - </span>
            <span>{moment(trip.CheckOutDate).format('MMM DD, YYYY')}</span>
          </div>
        </div>
        <div className="col-md-8 px-3 px-lg-4 py-3 trip-box-data">
          <h3 className={'title'}>{property?.name}</h3>
          <div className="flex space-between py-2 property-details">
            <span>
              <i className="fas fa-bed mr-1 icon-color-blue" />
              {property?.bedrooms} Bedrooms
            </span>
            <span className={'ml-3'}>
              {' '}
              <i className="fas fa-bath mr-1 icon-color-blue" />
              {property?.bathrooms} Bathrooms
            </span>
            <span className={'ml-3'}>
              <i className="fas fa-users mr-1 icon-color-blue" />
              Sleeps {property?.maximumGuests}
            </span>
          </div>
          <div className={'flex p-0 space-between trip-details'}>
            <div className="col-md-5 px-0 py-2">
              <div>
                <span className="header-text">Confirmation Number</span>
                <div className="body-text">{trip.BookingID}</div>
              </div>
            </div>
            {/*<div className="col-md-5 px-0 py-2">
              <div>
                <span className="header-text">Fully refundable until</span>
                <div className="body-text">{moment(trip.CheckOutDate).subtract(14, 'days').format('MMMM DD, YYYY')}</div>
              </div>
            </div>*/}
          </div>
          <div className={'flex center-content'}>
            <Button variant="dark" type="button" className="go-to-search-btn" onClick={goToTrip}>
              VIEW{!past && '/MODIFY'} DETAILS
            </Button>
          </div>
        </div>
      </div>
    </Col>
  );
}

export default Trip;
